import Header from './Headers';
import Const from '../util/Constants';
import Config from '../config/config';

class SmsAPI {

  static getList = (list, success, failure) => {
    const filter = list.filters;
    const page = list.pagination.currentPage;
    const perPage = list.pagination.perPage;
    fetch(Config.app.link + 'api/sms/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static getInnerList = (modelType, modelId, success, failure) => {
    const filter = [{field: 'model', type: 'model', 'condition': 'equals',
      value: `${modelType}~${modelId}`}];
    const page = 1;
    const perPage = 10;
    fetch(Config.app.link + 'api/sms/list', new Header('POST',  { filter, page, perPage }))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static send = (index, model_no, model_id, data, success, failure) => {
    const sms={ id: 0, model_no, model_id, type: 1, phone: data.phone.label, text: data.text, temp: data.temp };
    fetch(Config.app.link + 'api/sms/send', new Header('POST', sms))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }

  static delete = (id, success, failure) => {
    fetch(Config.app.link + 'api/sms/delete/' + id, new Header('GET'))
    .then(res => Const.ProcessAPI(res, success, failure))
    .catch(er => failure(er));
  }
}
export default SmsAPI;